import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "app-veicolo-carousel",
	templateUrl: "./veicolo-carousel.component.html",
	styleUrls: ["./veicolo-carousel.component.scss"],
})
export class VeicoloCarouselComponent {

	@Input()
	veicoli: Array<any>;

	@Output()
	veicoloSelezionato = new EventEmitter<any>();

	selezioneVeicolo(event) {
		this.veicoloSelezionato.emit(event);
	}
}